import matchData from '@/store/modules/storage/players/matchData';
import nonSelf from '@/store/modules/storage/players/nonSelf';
import roundData from '@/store/modules/storage/players/roundData';
import self from '@/store/modules/storage/players/self';

export default {
    matchData,
    nonSelf,
    roundData,
    self,
};
